import type { Response } from '../response';
import type { Promo } from '../../ontology/category';
import { get } from '../fetch-extension';

export default async function cms(): Promise<Response<Promo[]>> {
    return get<Promo[]>(`/cms/account`);
}


